import styled from 'styled-components'

export const Column = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
`